import { FC } from 'react'
import { MuiChipsInput } from 'mui-chips-input'

import { emailRegex } from '../../Utils/common'
import './style.scss'

interface inputChipProps {
    chips: string[],
    setChips: (chips: string[]) => void,
    placeholder: string,
    error: boolean,
    onBlur: () => void
}

const InputChipComponent: FC<inputChipProps> = ({ chips, setChips, placeholder, error, onBlur }) => {

    return (
        <MuiChipsInput
            className='mui-chip-container'
            inputMode='email'
            value={chips}
            onChange={setChips}
            placeholder={placeholder}
            error={error}
            onBlur={onBlur}
            size="small"
            variant="outlined"
            helperText={chips.length > 0 ? "Double click to edit a chip" : "Type and press enter to save"}
            validate={(chipValue) => {
                return {
                    isError: !emailRegex.test(chipValue),
                    textError: 'Please enter a valid email'
                }
            }}
        />
    )
}
export default InputChipComponent